export default "__VITE_ASSET__D5o2RmrY__"